module.exports = __webpack_public_path__ + "static/media/useCase13x.162fd7cf.png";